export const BACKLOG_PACKAGE_NAME = 'software-backlog' as const;

export const EXPERIENCE_TRACKER_LOCATION_BACKLOG = 'ng-backlog' as const;
export const EXPERIENCE_TRACKER_LOCATION_CMP_BACKLOG = 'cmp-backlog' as const;

export const ANALYTICS_SOURCE_BACKLOG = 'backlog' as const;

export const CMP_KANBAN_BOARD_TYPE = 'Kanban' as const;
export const CMP_SCRUM_BOARD_TYPE = 'Scrum' as const;
export const AGILITY_BOARD_TYPE = 'Agility' as const;
